import React from 'react';
import iceBondPoint from '../assets/ecosystem-compatibility-ice-bondpoint.webp'
import iceTmcBonds from '../assets/ecosystem-compatibility-ice-tmc-bonds.webp'
import bondsdotcom from '../assets/ecosystem-compatibility-bondsdotcom.webp'
import marketaxess from '../assets/ecosystem-compatibility-marketaxess.webp'
import mb from '../assets/ecosystem-compatibility-mb.webp'
import bloomberg from '../assets/ecosystem-compatibility-bloomberg.webp'
import tradeweb from '../assets/ecosystem-compatibility-tradeweb.webp'
import truemid from '../assets/ecosystem-compatibility-truemid.webp'
import openyield from '../assets/ecosystem-compatibility-openyield.webp'

import pershing from '../assets/ecosystem-compatibility-pershing.webp'
import wedbush from '../assets/ecosystem-compatibility-wedbush.webp'
import miraeAsset from '../assets/ecosystem-compatibility-miraeasset.webp'
import rbc from '../assets/ecosystem-compatibility-rbc.webp'
import finra from '../assets/ecosystem-compatibility-finra.webp'
import msrb from '../assets/ecosystem-compatibility-msrb.webp'
import lseg from '../assets/ecosystem-compatibility-lseg.webp'
import mifid from '../assets/ecosystem-compatibility-mifid.webp'

const EcosystemCompatibility = () => {
    // ========== ROW 1 LOGOS - Edit logos for the first scrolling row below ==========
    const row1Logos = [
        { id: 1, name: 'BondPoint', src: iceBondPoint },
        { id: 2, name: 'IceTmcBonds', src: iceTmcBonds },
        { id: 3, name: 'Bondsdotcom', src: bondsdotcom },
        { id: 4, name: 'Marketaxess', src: marketaxess },
        { id: 5, name: 'Mb', src: mb },
        { id: 6, name: 'Bloomberg', src: bloomberg },
        { id: 7, name: 'Tradeweb', src: tradeweb },
        { id: 8, name: 'Truemid', src: truemid },
        { id: 9, name: 'OpenYield', src: openyield },
    ];

    // ========== ROW 2 LOGOS - Edit logos for the second scrolling row below ==========
    const row2Logos = [
        { id: 1, name: 'Pershing', src: pershing },
        { id: 2, name: 'Wedbush', src: wedbush },
        { id: 3, name: 'MIRAE ASSET', src: miraeAsset },
        { id: 4, name: 'RBC', src: rbc },
        { id: 5, name: 'FINRA', src: finra },
        { id: 6, name: 'MSRB', src: msrb },
        { id: 7, name: 'LSEG', src: lseg },
        { id: 8, name: 'MIFID', src: mifid },
    ];

    return (
        <section className="w-full bg-[#070E21] py-20 overflow-hidden">
            <div className="site-shell mb-12">
                <h2 className="font-oswald text-white text-3xl md:text-4xl font-bold uppercase text-center tracking-wide">
                    COMPATIBLE WITH YOUR EXISTING ECOSYSTEM<span className="text-gray-500">*</span>
                </h2>
            </div>

            {/* Row 1 - First Scrolling Row */}
            <div className="relative w-full overflow-hidden flex mb-6">
                {/* Set 1 */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 flex-shrink-0 items-center">
                    {row1Logos.map((logo) => (
                        <div
                            key={`row1-set1-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center w-[160px] h-[70px] md:w-[160px] md:h-[70px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                {/* Set 2 (Duplicate for seamless loop) */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 flex-shrink-0 items-center" aria-hidden="true">
                    {row1Logos.map((logo) => (
                        <div
                            key={`row1-set2-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center w-[160px] h-[70px] md:w-[160px] md:h-[70px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                {/* Set 3 (Duplicate for seamless loop) */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 flex-shrink-0 items-center" aria-hidden="true">
                    {row1Logos.map((logo) => (
                        <div
                            key={`row1-set2-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center w-[160px] h-[70px] md:w-[160px] md:h-[70px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Row 2 - Second Scrolling Row */}
            <div className="pl-24 relative w-full overflow-hidden flex">
                {/* Set 1 */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 flex-shrink-0 items-center">
                    {row2Logos.map((logo) => (
                        <div
                            key={`row2-set1-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center w-[160px] h-[70px] md:w-[160px] md:h-[70px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                {/* Set 2 (Duplicate for seamless loop) */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 flex-shrink-0 items-center" aria-hidden="true">
                    {row2Logos.map((logo) => (
                        <div
                            key={`row2-set2-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center w-[160px] h-[70px] md:w-[160px] md:h-[70px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
                {/* Set 3 (Duplicate for seamless loop) */}
                <div className="flex animate-scroll gap-6 md:gap-8 pr-6 md:pr-8 flex-shrink-0 items-center" aria-hidden="true">
                    {row2Logos.map((logo) => (
                        <div
                            key={`row2-set2-${logo.id}`}
                            className="bg-white rounded-[4px] flex items-center justify-center w-[160px] h-[70px] md:w-[160px] md:h-[70px] flex-shrink-0 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={`${logo.name} Logo`}
                                className="max-w-full max-h-full object-contain"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Disclaimer Text */}
            <div className="site-shell mt-8 text-center">
                <p className="text-gray-400 text-sm italic">
                    *All product names, logos, brands, and trademarks featured above are the property of their respective owners.
                </p>
            </div>
        </section>
    );
};

export default EcosystemCompatibility;
